

































import { SdsIcon } from '@superbet-group/web.lib.ui-components';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'SdsAccountListItem',
    emits: ['click'],
    props: {
        iconName: {
            type: String,
            required: false,
            default: undefined,
        },
        isIconThemed: {
            type: Boolean,
            required: false,
            default: false,
        },
        showChevron: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    components: {
        SdsIcon,
    },
});
